import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["main", "result", "totalNotification", "connectionIcon", "sessionTimer", "logo", "9999"]

  connect() {
    this.setUserName()
    this.doNavbarHtml()
  }

  connectionOn() {
    this.connectionIconTarget.classList.add("md-success")
    this.connectionIconTarget.classList.remove("md-danger")
    this.connectionIconTarget.dataset.connection = true
    this.connectionIconTarget.parentElement.dataset.originalTitle = "Conectado"
  }

  connectionOff() {
    this.connectionIconTarget.classList.add("md-danger")
    this.connectionIconTarget.classList.remove("md-success")
    this.connectionIconTarget.dataset.connection = false
    this.connectionIconTarget.parentElement.dataset.originalTitle = "Sem Conexão"
  }

  tryReconnect() {
    var status = this.getControllerByIdentifier("app--helpers--strings").fromStringToBoolean(this.connectionIconTarget.dataset.connection)    
  }

  setUserName() {
    if (this.application.current_user.account_kind == "doctor") {
      if (this.application.current_user.sex == "male") {
        this.application.user_name = `Dr. ${this.application.current_user.name.split(" ")[0]}`
      } else {
        this.application.user_name = `Dra. ${this.application.current_user.name.split(" ")[0]}`
      }
    } else if (this.application.current_user.account_kind == "admin" || this.application.current_user.account_kind == "team") {
      this.application.user_name = this.application.current_user.name.split(" ")[0]
    } else if (this.application.current_user.account_kind == "helper") {
      this.application.user_name = this.application.current_user.name.split(" ")[0]
    }
  }

  showNotifications() {
    this.getControllerByIdentifier("app--communications--notifications--entities").showNotifications()
  }

  updateTotalNotifications() {
    if (this.application.notifications.length > 0) {
      this.totalNotificationTarget.innerText = this.application.notifications.length
    } else {
      this.totalNotificationTarget.innerText = ``
    }
  }

  goToDashboard() {
    window.open(`/dashboard`, `_self`)
  }

  doNavbarHtml() {
    if (this.application.current_user.account_kind == "admin" || this.application.current_user.account_kind == "team") {
      var profileLink = `/a/minha-conta/${this.application.current_user.token}`
    } else if (this.application.current_user.account_kind == "doctor") {
      var profileLink = `/d/minha-conta/${this.application.current_user.token}`
    } else if (this.application.current_user.account_kind == "helper") {
      var profileLink = `/h/minha-conta/${this.application.current_user.token}`
    }

    var html2 = `<li>
                  <a class="nav-link nav-link-text a-dark pointer" style="padding:5px;" data-toggle="tooltip" data-placement="left" title="Conexão" id="appConnection" data-action="click->app--navigation--desktop--navbar#tryReconnect"><span class="material-icons" data-app--navigation--desktop--navbar-target="connectionIcon">settings_remote</span></a>
                </li>`

    var html1 = `<li>
                  <a class="notice nav-link nav-link-text a-dark pointer" style="padding:5px;" data-toggle="tooltip" data-placement="left" title="Notificações" data-action="click->app--navigation--desktop--navbar#showNotifications"><span class="material-icons">notification_important</span><span class="badge badge-danger notice-badge" data-app--navigation--desktop--navbar-target="totalNotification"></span></a>
                </li>`

    var html = `<ul class="nav navbar-nav navbar-right">
              <li>
                <a class="nav-link nav-link-text a-dark pointer" style="padding:5px;" data-toggle="tooltip" data-placement="left" title="Conexão" id="appConnection" data-action="click->app--navigation--desktop--navbar#tryReconnect"><span class="material-icons" data-app--navigation--desktop--navbar-target="connectionIcon">settings_remote</span></a>
              </li>
              <li>
                <a class="d-flex align-items-center nav-link nav-link-text a-dark pointer" data-toggle="tooltip" data-placement="top" title="Minha Conta" href="${profileLink}">${this.application.user_name}</span></a>
              </li>
              
              <li>
                <a class="d-flex align-items-center nav-link nav-link-text a-dark pointer" data-toggle="tooltip" data-placement="top" title="Renovar Sessão?" data-app--navigation--desktop--navbar-target="sessionTimer" data-action="click->app--navigation--desktop--navbar#renewalLogin"></span></a>
              </li>
              <li>
                <a class="d-flex align-items-center nav-link nav-link-text nav-link-danger a-dark" data-method="delete" href="/sair" data-toggle="tooltip" data-placement="bottom" title="Sair"><i class="material-icons">exit_to_app</i></a>
              </li>
            </ul>`

    
    this.mainTarget.insertAdjacentHTML("beforeend", html)
  }

  renewalLogin() {
    this.getControllerByIdentifier(`app--communications--connection--login`).renewalLogin()
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }


}
